<template>
    <div class="body edit-panel flex flex-col gap-4">
    <div v-if="showHotKeys" class="tb-form-group">
      <hot-keys
        :item="item"
        :editing="editing"
        :panel="panel"
        :production_context="production_context"
      />
    </div>

    <div class="tb-form-group">
      <label class="tb-label">Title</label>

      <input
        class="tb-input"
        type="text"
        :value="title"
        data-entity="producer-editor-themeTitle"
        data-test="interactive-editor-title"
        @keyup.right.stop
        @keyup.left.stop
        @input="setTitle"
      />
    </div>

    <component
      :is="panel.type"
      :editing="editing"
      :item="item"
      :panel="panel"
      :production_context="production_context"
    />
  </div>
</template>

<script>
import HotKeys from './hotkeys/HotKeys.vue';

// TODO: Move all these out of nested folders. There's no need for that much abstraction.
import PollResultsComponent from './panels/pollresults/PollResults.vue';
import HashtagBattleComponent from './panels/hashtagpoll/HashtagBattle.vue';
import TwitterPollComponent from './panels/twitterpoll/TwitterPoll.vue';
import GraphicPanelComponent from './panels/graphic/GraphicPanel.vue';
import CallToActionComponent from './panels/calltoaction/CallToAction.vue';
import WidgetComponent from './panels/widget/Widget.vue';
import TimerComponent from './panels/timer/Timer.vue';
import HeatmapComponent from './panels/heatmap/Heatmap.vue';
import CountdownComponent from './panels/countdown/Countdown.vue';
import LeaderboardComponent from './panels/leaderboard/Leaderboard.vue';
import YoutubeComponent from './panels/youtube/YouTube.vue';
import VimeoComponent from './panels/vimeo/Vimeo.vue';
import RedditPollComponent from './panels/redditpoll/RedditPoll.vue';

export default {
  props: ['editing', 'item'],

  components: {
    HotKeys,

    'poll-results': PollResultsComponent,
    'hashtag-battle': HashtagBattleComponent,
    'hashtag-meter': HashtagBattleComponent,
    'twitter-poll': TwitterPollComponent,
    graphic: GraphicPanelComponent,
    cta: CallToActionComponent,
    widget: WidgetComponent,
    timer: TimerComponent,
    countdown: CountdownComponent,
    heatmap: HeatmapComponent,
    leaderboard: LeaderboardComponent,
    youtube: YoutubeComponent,
    vimeo: VimeoComponent,
    'reddit-poll': RedditPollComponent,
  },

  data() {
    return {
      isQrCodeEnabled: process.env.QR_CODE_SWITCH === 'ON',
    };
  },

  computed: {
    // Only show hot keys component if the panel has animations.
    showHotKeys() {
      const { settings } = this.panel;
      return settings?.animations?.length;
    },

    panel() {
      return this.$store.state.panels.lookupTable[this.item._id];
    },

    title() {
      return this.editing?.title || this.item.title || this.panel.title;
    },

    currentLayoutIndex() {
      return this.$store.state.production.production.index;
    },

    isCurrentLayout() {
      return this.item && (this.editing.timeline_id === this.currentLayoutIndex);
    },

    currentSampleLayoutIndex() {
      return this.$store.state.preview.production.index;
    },

    isCurrentSampleLayout() {
      return this.item && (this.currentSampleLayoutIndex === this.editing.timeline_id);
    },

    production_context() {
      return { live: this.isCurrentLayout, preview: this.isCurrentSampleLayout };
    },
  },

  methods: {
    async sendSampleUpdate() {
      this.$store.dispatch('updatePreviewTimeline', { force: true });
    },

    async sendUpdate() {
      this.$store.dispatch('updateTimeline', { force: true });
    },

    setTitle($event) {
      this.$store.dispatch('setTimelineTitle', {
        timelineId: this.editing?.timeline_id,
        title: $event.target.value,
      });

      // Debounce send over the socket.
      // Otherwise we'll send a message every character, which is annoying.
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.$store.dispatch('updateTimeline');
        this.$store.dispatch('updatePreviewTimeline');
      }, 500);
    },
  },
};
</script>
